













import { mapGetters, mapActions } from 'vuex';

import Vue from 'vue';

export default Vue.extend({
  name: 'LoginIndicator',
  computed: {
    ...mapGetters('auth', ['isAuthenticated', 'currentUser']),
  },
  methods: {
    ...mapActions('auth', ['LOGOUT_USER']),
    onLogout(): void {
      this.LOGOUT_USER();
      this.$router.push({ path: '/' });
      this.$toast.open('Signed out!');
    },
  },
});
